import compact from 'lodash/compact'
import flatMap from 'lodash/flatMap'
import find from 'lodash/find'
import { ReplenishmentOrder } from './types'

export const findReplenishmentSlotActiveOrder = (
  replenishmentOrders: ReplenishmentOrder[],
  slotType: 'solid' | 'liquid',
  slotNumber: number
): number | null => {
  const order = find(replenishmentOrders, order => {
    return find(order.productReplenishments, repl => {
      const matchingSlotType = repl.containerType === slotType
      const matchingSlotNumber = repl.slotNumber === slotNumber
      const notCanceled = repl.state !== 'canceled'

      return matchingSlotType && matchingSlotNumber && notCanceled
    })
  })

  return order?.id || null
}


export const findProductReplenishmentName = (
  replenishmentOrders: ReplenishmentOrder[],
  slotType: 'solid' | 'liquid',
  slotNumber: number
): string => {
  let replenishmentProductName = ''
  replenishmentOrders.forEach(order => {
    order.productReplenishments.forEach(replenishment => {
      const matchingSlotType = replenishment.containerType === slotType
      const matchingSlotNumber = replenishment.slotNumber === slotNumber
      const notCanceled = replenishment.state !== 'canceled'

      if(matchingSlotType && matchingSlotNumber && notCanceled) {
        replenishmentProductName = replenishment?.product?.name || 'Empty'
      }
    })
  })

  return replenishmentProductName
}
